import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function OutdoorLiving() {
  return (
    <section
      id="outdoors"
      aria-labelledby="outdoors-heading"
      className="relative isolate overflow-hidden bg-primary text-primary-foreground"
    >
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-18 md:py-24">
        <div className="max-w-2xl border border-primary-foreground/20 bg-forest-deep/55 p-8 backdrop-blur-sm md:p-12">
          <Reveal>
            <Eyebrow tone="light">Enjoy the Outdoors</Eyebrow>
          </Reveal>
          <h2 id="outdoors-heading" className="display-lg mt-6">
            <MaskReveal>Your Campsite Isn&apos;t the</MaskReveal>
            <MaskReveal delay={0.08}>Only Place to Unwind</MaskReveal>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base leading-relaxed text-primary-foreground/80">
              Step outside, slow down and enjoy Auburn&apos;s California atmosphere with convenient
              outdoor spaces throughout the resort.
            </p>
          </Reveal>
          <Reveal delay={0.14}>
            <div className="mt-10 grid gap-6 sm:grid-cols-2">
              <div>
                <h3 className="eyebrow text-accent">Picnic Tables</h3>
                <p className="mt-3 text-sm leading-relaxed text-primary-foreground/75">
                  Outdoor picnic tables give guests a simple place to enjoy meals, coffee or time
                  outside.
                </p>
              </div>
              <div>
                <h3 className="eyebrow text-accent">BBQ Area</h3>
                <p className="mt-3 text-sm leading-relaxed text-primary-foreground/75">
                  A dedicated BBQ area makes it easy to enjoy an outdoor meal during your stay.
                </p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.18}>
            <ResortLink variant="gold" href="/reservations/" className="mt-10 w-full sm:w-auto">
              Plan Your Stay
            </ResortLink>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
